<template>
    <div
        class="h-100 w-100 d-flex flex-column justify-content-start align-items-center"
    >
        <p v-if="error" class="text-danger">{{ errorMsg }}</p>

        <b-tabs
            id="rfx-setup-wizard"
            ref="setupWizardTabs"
            no-nav-style
            justified
            :vertical="isVerticalTabs"
            v-model="currentTabIndex"
            :nav-wrapper-class="[
                'mh-nav-wrapper-class',
                isVerticalTabs ? 'vertical col-2' : 'horizontal',
            ]"
            :nav-class="[
                'spl-step-nav',
                'sticky-top',
                isVerticalTabs ? 'pt-4' : 'horizontal mt-3',
            ]"
            content-class="d-flex flex-column px-0"
            active-tab-class="h-100"
            @activate-tab="handleTabChange"
            @input="handleTabInputEvent"
            class="h-100 w-100 flex-nowrap"
            :class="isVerticalTabs ? 'vertical' : 'horizontal'"
        >
            <template v-if="isVerticalTabs" #tabs-start>
                <h3 class="mb-3 text-muted">Event Setup</h3>
            </template>

            <b-tab
                ref="basicSettingsTab"
                id="basicSettingsTab"
                lazy
                class="d-flex flex-column"
            >
                <template #title>
                    <div class="d-flex align-items-center">
                        <number-round text="1" class="mr-2"></number-round>
                        Settings
                    </div>
                </template>
                <rfx-wizard-top-bar
                    title="Settings"
                    description="Event name, status, categories, tags, event timeline, and other basic settings."
                    stepNumber="1"
                    :disabled-save="isReadOnly"
                    :disabled-next="isReadOnly"
                    @previous="currentTabIndex--"
                    @save="saveComponent('rfxSetupConfig')"
                    @next="saveNext('rfxSetupConfig')"
                ></rfx-wizard-top-bar>
                <rfx-setup-config
                    ref="rfxSetupConfig"
                    id="rfxSetupConfig"
                    :rfx-pk="rfxId"
                    :is-read-only="isReadOnly"
                    class="animate__animated animate__fadeIn animate__fast rfx-wizard-content-area"
                ></rfx-setup-config>
            </b-tab>

            <b-tab
                ref="contentItemsTab"
                id="contentItemsTab"
                lazy
                class="d-flex flex-column"
            >
                <template #title>
                    <div class="d-flex align-items-center">
                        <number-round text="2" class="mr-2"></number-round>
                        Content
                    </div>
                </template>
                <rfx-wizard-top-bar
                    title="Content"
                    description="Describe what you are sourcing & add attachments."
                    stepNumber="2"
                    :disabled-save="isReadOnly"
                    :disabled-next="isReadOnly"
                    @previous="currentTabIndex--"
                    @save="saveComponent('rfxContentComponent')"
                    @next="saveNext('rfxContentComponent')"
                ></rfx-wizard-top-bar>
                <rfx-content
                    ref="rfxContentComponent"
                    id="rfxContentComponent"
                    :rfx-id="rfxId"
                    :is-read-only="isReadOnly"
                    class="animate__animated animate__fadeIn animate__fast rfx-wizard-content-area"
                ></rfx-content>
            </b-tab>

            <b-tab
                ref="responseFormsTab"
                id="responseFormsTab"
                lazy
                class="d-flex flex-column"
            >
                <template #title>
                    <div class="d-flex align-items-center">
                        <number-round text="3" class="mr-2"></number-round>
                        Response
                    </div>
                </template>
                <rfx-wizard-top-bar
                    title="Response"
                    description="Choose what suppliers must complete when submitting a response:  forms, pricing sheets, or filling in a document."
                    stepNumber="3"
                    :disabled-save="isReadOnly"
                    :disabled-next="isReadOnly"
                    @previous="currentTabIndex--"
                    @save="saveComponent('setupFormsComponent')"
                    @next="saveNext('setupFormsComponent')"
                ></rfx-wizard-top-bar>
                <!-- below WAS rfx-setup-forms -->
                <rfx-setup-response
                    ref="setupFormsComponent"
                    id="setupFormsComponent"
                    :rfx-id="rfxId"
                    :is-read-only="isReadOnly"
                    class="animate__animated animate__fadeIn animate__fast rfx-wizard-content-area"
                ></rfx-setup-response>
            </b-tab>

            <!-- <b-tab 
                ref="decisionCriteriaTab"
                id="decisionCriteriaTab"
                lazy
            >
                <template #title>
                    <div class="d-flex align-items-center">
                        <number-round text="4" class="mr-2"></number-round>
                        Score Sheet
                    </div>                              
                </template>
                <rfx-wizard-top-bar
                    title="Score Sheet"
                    description="Build a score sheet with your internal decision criteria to evaluate supplier responses."
                    stepNumber="4"
                    :disabled-save="isReadOnly"
                    :disabled-next="isReadOnly"
                    @previous="currentTabIndex--"
                    @save="saveComponent('criteriaComponent')"
                    @next="saveNext('criteriaComponent')"
                ></rfx-wizard-top-bar>
                <rfx-manage-criteria 
                    ref="criteriaComponent"
                    id="criteriaComponent"
                    :rfx-pk="rfxId"
                    class="animate__animated animate__fadeIn animate__fast rfx-wizard-content-area"
                ></rfx-manage-criteria>
            </b-tab> -->

            <b-tab
                ref="internalTeamTab"
                id="internalTeamTab"
                lazy
                class="d-flex flex-column"
            >
                <template #title>
                    <div class="d-flex align-items-center">
                        <number-round text="4" class="mr-2"></number-round>
                        Team
                    </div>
                </template>
                <rfx-wizard-top-bar
                    title="Team"
                    description="Add other internal team members to collaborate on this sourcing event."
                    stepNumber="4"
                    :disabled-save="isReadOnly"
                    :disabled-next="isReadOnly"
                    @previous="currentTabIndex--"
                    @save="saveComponent('teamComponent')"
                    @next="saveNext('teamComponent')"
                ></rfx-wizard-top-bar>
                <rfx-manage-team
                    ref="teamComponent"
                    id="teamComponent"
                    :rfx-pk="rfxId"
                    :is-read-only="isReadOnly"
                    class="animate__animated animate__fadeIn animate__fast rfx-wizard-content-area"
                ></rfx-manage-team>
            </b-tab>

            <b-tab
                ref="launchTab"
                id="launchTab"
                lazy
                class="d-flex flex-column"
            >
                <template #title>
                    <div class="d-flex align-items-center">
                        <number-round text="5" class="mr-2"></number-round>
                        Launch
                    </div>
                </template>
                <rfx-wizard-top-bar
                    title="Launch"
                    description="Launch the event and start receiving supplier responses."
                    stepNumber="5"
                    :disabled-save="isReadOnly"
                    :disabled-next="isReadOnly"
                    @previous="currentTabIndex--"
                    hide-next
                    hide-save
                ></rfx-wizard-top-bar>
                <!-- LAUNCH component is just completely hidden if RfxTenantUser is not admin -->
                <rfx-setup-launch
                    ref="launchComponent"
                    id="launchComponent"
                    v-if="!isReadOnly"
                    key="launchComponent"
                    :rfx-id="rfxId"
                    class="mt-3 rfx-wizard-content-area"
                    @go-to-tab="handleGoToTab"
                    @tab-error="handleTabError"
                ></rfx-setup-launch>
                <div v-else key="launchNotShown" class="mt-3 rfx-wizard-content-area">
                    <div class="h-100 w-100 d-flex align-items-center justify-content-center">
                        <div class="text-muted font-weight-bold font-size-100">
                            Not shown based on your role or status of the Sourcing Event.
                        </div>
                    </div>
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
/* HOW TO USE:
- All major "form" components in tabs should have these 2 methods on them that get called from parent:
    - saveAll() (no args) 
        - should handle saving things in the component, or prompting user to discard changes
        - return an OBJECT that has 2 key/values structured like below:
            - {
                statusPromise: returnPromise,  // a PROMISE that resolves to Boolean -- true = continue, false = don't continue
                successMessage: 'Basic settings saved',  // not used anymore... will show success toast inside the component
            };
    - okToContinue()  (no args) 
        - should check if its OK to navigate away from this tab, prompting & handling saving of unsaved changes if needed
        - should return a PROMISE that resolves to Boolean.  true = continue to navigate away, false = don't continue with navigating away
    
- Also make sure all components are included in this.tableRefMap below
*/

import { errorMessageMaker } from "../js/filters-helpers";
import RfxContent from "./RfxContent";
import RfxWizardTopBar from "./RfxWizardTopBar";
import NumberRound from "./functional-comps/NumberRound";
import RfxSetupResponse from "./rfx_internal/RfxSetupResponse";
import { currentUserInfoMixin } from '../js/custom-vue-mixins';

export default {
    name: "RfxWizard",
    components: {
        RfxContent,
        RfxSetupResponse, // new version of RfxSetupForms
        RfxWizardTopBar,
        NumberRound,
    },
    mixins: [ 
        currentUserInfoMixin,
    ],
    props: {
        rfxId: {
            type: [String, Number],
            required: true,
        },
        rtuRole: {
            // role of the RfxTenantUser - 'admin', 'decision', 'requester' OR '' if tenant settings allow non-team-members to view RFXs
            type: String,
            required: true,
        },
    },
    data: function () {
        return {
            errorMsg: "Error",
            error: false,
            currentTabIndex: 0, // used to control which tab you're on
            currentTabProceedUnsaved: false, // flag checked during handleTabChange, if set to true we will continue with tab change even if there are unsaved changes.  must reset to false when new tab is activated.
            componentWidth: null,
            tabRefMap: {
                // map of api tab names to tab ref names used on this component - API will check things then report type/where error is (settings, content, etc...)
                settings: "basicSettingsTab",
                content: "contentItemsTab",
                forms: "responseFormsTab",
                criteria: "decisionCriteriaTab",
                team: "internalTeamTab",
                invites: "inviteSettingsTab",
            },
        };
    },
    computed: {
        /* componentWidth: function() {
            if (this.$el) return this.$el.scrollWidth;
            return null;
        }, */
        isVerticalTabs: function () {
            if (this.componentWidth) return this.componentWidth > 900;
            return true; // fallback
        },
        isReadOnly() {
            // if RTU is not admin, we allow showing this to 'decision' team -- configurable per tenant whether it is shown or not, but as of Nov 9 2022, it is always read only if non-admin
            // based on tenant flag: allow_rtu_decision_readonly_setup
            // IMPORTANT - we cannot ONLY check the rtuRole
            // if TU is TenantAdmin/SuperAdmin, we will NOT set isReadOnly = true
            const isReadOnlyForRtuRole = this.rtuRole !== 'admin';
            return this.$currentUserInfo.is_tenant_admin ? false : isReadOnlyForRtuRole;  // if tenant admin, not read only.  but if not tenant admin, then use rtu role.
        },
    },
    mounted: function () {
        this.setComponentWidth();
    },
    created: function () {
        this.currentTabIndex = parseInt(location.hash.replace("#", "") || 0);
    },
    methods: {
        handleError: function (error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = errorMessageMaker(message);
            this.error = true;
        },
        setComponentWidth: function () {
            // sets width data property so UI can adjust properly... a hack for making things responsive
            if (this.$el) {
                this.componentWidth = this.$el.scrollWidth;
            }
        },
        /* validateComponent: function(refComponent) {
            // calls .validateAll() on a ref component 
            // MUST IMPLEMENT .validateAll() on each component, or else manually make exception for a certain ref here
            // should return a PROMISE that resolves to Boolean:  true = is valid
            // use this as a way to check that a step is valid before submit / launch event
            return this.$refs[refComponent].validateAll();  // returns a PROMISE that resolves to Boolean
        }, */
        saveComponent: function (refComponent) {
            // calls .saveAll() on ref component
            // returns OBJECT with 2 keys:  'statusPromise'(Promise) and 'successMessage'(string) - statusPromise is PROMISE that resolves to T/F based on success of saveAll()
            // get return values from .saveAll() using object destructuring
            let { statusPromise, successMessage } =
                this.$refs[refComponent].saveAll();
            return statusPromise.then((saveSuccess) => {
                // saveSuccess is the boolean value the 'statusPromise' promise resolves to
                if (saveSuccess === true) {
                    /* let finalSuccessMsg = successMessage || 'Settings Saved';
                    this.$toast.success(finalSuccessMsg);  */ // moved success message to the components
                    console.log(
                        `should be showing a toast for: ${successMessage}`
                    );
                }
                return saveSuccess; // return the original value from statusPromise
            });
        },
        saveNext: function (refComponent) {
            // calls .saveAll() on ref component via this.saveComponent, then increments currentTabIndex
            let saveAllResult = this.saveComponent(refComponent); // returns a PROMISE that resolves to T/F
            console.log(
                "Result of saveAll on component below, variable is saveAllResult and it should be a PROMISE"
            );
            console.log(saveAllResult);
            saveAllResult
                .then((saveSuccess) => {
                    // saveSuccess is the Boolean returned from .saveComponent / ref.saveAll()
                    if (saveSuccess === true) {
                        this.currentTabIndex++;
                    } else {
                        console.log(
                            "in RfxWizard saveNext method, saveAllResult is false, so not proceeding"
                        );
                    }
                    // maybe no need for anything else, since errors should be shown on the component?... actually you need a .catch after your .then in case things return error?
                })
                .catch((error) =>
                    this.handleError(
                        error,
                        "Error from RfxWizard saveNext method"
                    )
                );
        },
        handleGoToTab: function (tabName) {
            // handle request from launch component to go to a certain tab to fix a problem - tab name is api name for it
            let tabRefName = this.tabRefMap[tabName]; // lookup the ref for this tab (as used on THIS component)
            if (tabRefName) {
                // only if you found the tabRev...
                this.$refs[tabRefName].activate(); // go there via activate() method
            }
        },
        handleTabError: function (tabErrorNamesArray) {
            // handles reporting of errors from launch component, arg/payload is array of tab names (api format) = 'settings' 'content' 'forms' 'criteria'
            // not sure what to do here yet... save for later
            console.log(tabErrorNamesArray);
        },
        requestReloadHeader: function () {
            // emit event to parent to request reload of header component (ref="rfxInternalHeader")
            // call this when you change data that is shown in header
            this.$emit("reload-header");
        },
        handleTabChange: function (newTabIndex, prevTabIndex, bvEvt) {
            // old version using confirmation modal on child component returning PROMISE
            // this gets called whenever a new tab is shown/activated
            // tab indexes are 0-based
            // can cancel the activation using bvEvt.preventDefault() if .canLeaveTab returns false for current tab, for example
            console.log(
                `From handleTabChange, newTabIndex is ${newTabIndex}, prevTabIndex is ${prevTabIndex}, then event below`
            );
            console.log(bvEvt);
            let currentTabComponent =
                this.$refs.setupWizardTabs.tabs[prevTabIndex]; // returns the b-tab component
            let componentToCheck = currentTabComponent.$children.find((comp) =>
                Object.keys(comp).includes("okToContinue")
            ); // returns FIRST component that has okToContinue method, otherwise undefined if not found
            if (componentToCheck && !this.currentTabProceedUnsaved) {
                // check if we set the override for going to next tab with unsaved changes
                bvEvt.preventDefault(); // do this right away (only if we didn't already set override), then manually activate newTabIndex if all OK
                // pass the event to the okToContinue method so that method can call preventDefault() on it if needed!
                let okToContinuePromise = componentToCheck.okToContinue(bvEvt); // returns a promise saying OK to continue or not, and shows modal to let user handle unsaved changes
                console.log(
                    `from handleTabChange, okToContinuePromise is below for component with id: ${componentToCheck.$el.id}`
                );
                console.log(okToContinuePromise);
                okToContinuePromise.then((canContinue) => {
                    // let the promise resolve
                    if (canContinue) {
                        // if we returned true, manually go to newTabIndex which should work if you set flag correctly in child component
                        console.log(
                            "From inside rfx wizard handleTabChange, promise from component resolved to TRUE"
                        );
                        this.currentTabProceedUnsaved = true; // must set this first so we skip this check when setting new tab index manually
                        this.currentTabIndex = newTabIndex; // this should redirect to new tab, as long as we set override above
                        location.hash = newTabIndex;
                    } else {
                        console.log(
                            "From inside rfx wizard handleTabChange, promise from component resolved to NOT TRUE, so no tab change"
                        );
                    }
                });
            }
        },
        /* handleTabChange: function(newTabIndex, prevTabIndex, bvEvt) {  // NEW version using syncronous method instead
            // this gets called whenever a new tab is shown/activated
            // tab indexes are 0-based
            // can cancel the activation using bvEvt.preventDefault() if .canLeaveTab returns false for current tab, for example
            //bvEvt.preventDefault();  // do this right away, then manually activate newTabIndex if all OK
            console.log(`From handleTabChange, newTabIndex is ${newTabIndex}, prevTabIndex is ${prevTabIndex}, then event below`);
            console.log(bvEvt);
            let currentTabComponent = this.$refs.setupWizardTabs.tabs[prevTabIndex];  // returns the b-tab component
            let componentToCheck = currentTabComponent.$children.find(comp => Object.keys(comp).includes('okToContinue'));  // returns FIRST component that has okToContinue method, otherwise undefined if not found
            if (componentToCheck && !this.currentTabProceedUnsaved) {  // if we have a tab to check, and we didn't already set currenTabProceedUnsaved = true
                let notOkToLeaveMessage = componentToCheck.checkOkToLeave ? componentToCheck.checkOkToLeave() : '';  // if NOT ok, this returns a message string, if OK, returns empty string
                //let okToContinuePromise = componentToCheck.okToContinue(bvEvt);  // returns a promise saying OK to continue or not, and shows modal to let user handle unsaved changes
                console.log(`from handleTabChange, notOkToLeaveMessage is below for component with id: ${componentToCheck.$el.id}`);
                console.log(notOkToLeaveMessage);
                if (notOkToLeaveMessage) {
                    bvEvt.preventDefault();  // cancel the tab change, then show confirm modal, then proceed accordingly
                    console.log('We just cancelled the tab change.');
                    let shouldContinue = this.$bvModal.msgBoxConfirm(notOkToLeaveMessage, {
                        title: 'Please Confirm',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Yes, Discard Changes',
                        cancelTitle: 'No, Cancel',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                        });  // don't need to chain more... msgBoxConfirm will return true if OK was clicked, falsy otherwise
                    shouldContinue.then(value => {
                        if (value) {
                            this.currentTabProceedUnsaved = true;  // must set this first
                            this.currentTabIndex = newTabIndex;  // go to new tab manually
                        }
                    });
                } else {
                    console.log('We are proceeding with the tab change.');
                    // we will proceed normally, since we only did preventDefault() from within the if block, this is in else block
                }
            }
        }, */
        handleTabInputEvent: function (newTabIndex) {
            // use this to reset things when we change tabs, like currentTabProceedUnsaved
            console.log(
                "Just navigated to tabIndex: " + newTabIndex.toString()
            );
            this.currentTabProceedUnsaved = false; // reset this
        },
    },
};
</script>

<style lang="scss">
#rfx-setup-wizard {
    // we add .vertical and .horizontal to this based on layout - horizontal for small screen sizes, vertical for wide screens

    .mh-nav-wrapper-class {
        // this is a col
        &.vertical {
            background-color: var(--gray-200);
            border-right: 1px solid var(--gray-300);
            display: flex;
            justify-content: flex-end;
            min-width: 160px;
        }
        &.horizontal {
            background-color: var(--gray-200);
        }
    }

    &.vertical {
        .rfx-wizard-top-bar {
            border-bottom: 1px solid var(--gray-300);
            //background-color: var(--gray-100);
            padding: 1rem 2rem 1rem 2rem;
        }

        .rfx-wizard-content-area {
            flex: 1 1 auto !important; // this is flex-fill
            overflow-y: auto;
            padding: 2rem;
        }
    }
    &.horizontal {
        .rfx-wizard-top-bar {
            border-bottom: none;
            //background-color: none;
            padding: 0.5rem 1rem 0.5rem 1rem;
        }

        .rfx-wizard-content-area {
            flex: 1 1 auto !important; // this is flex-fill
            overflow-y: auto;
            padding: 1rem;
        }
    }
}
</style>
